import React, { ReactNode } from "react";
import { getClassNames } from "../../utils";
import Icon, {
    ICON_TYPE_WARNING,
    ICON_TYPE_INFOBOX,
    ICON_TYPE_CHECK_FILLED,
    ICON_INFO_SLIM,
} from "../Icon";
import "./Infobox.css";
import withTheme from "../../hocs/withTheme";

type IconType =
    | typeof ICON_TYPE_WARNING
    | typeof ICON_TYPE_INFOBOX
    | typeof ICON_TYPE_CHECK_FILLED
    | typeof ICON_INFO_SLIM;

interface InfoboxProps {
    accent?: boolean;
    error?: boolean;
    success?: boolean;
    warning?: boolean;
    children?: ReactNode;
    className?: string;
    showIcon?: boolean;
    icon?: IconType;
}

const iconByType: Record<"accent" | "error" | "success", IconType> = {
    accent: ICON_TYPE_INFOBOX,
    error: ICON_TYPE_WARNING,
    success: ICON_TYPE_CHECK_FILLED,
};

function Infobox({
    accent = false,
    error = false,
    success = false,
    warning = false,
    children = null,
    className,
    showIcon = true,
    icon,
}: InfoboxProps) {
    const infoboxClassName = getClassNames(
        "Info-box",
        className,
        { "info-box_accent": accent },
        { "info-box_error": error },
        { "info-box_success": success },
        { "info-box_warning": warning }
    );

    const iconType =
        ([
            { type: accent, icon: iconByType.accent },
            { type: error, icon: iconByType.error },
            { type: success, icon: iconByType.success },
        ]
            .filter(({ type }) => type)
            .pop()?.icon) || ICON_INFO_SLIM;

    return (
        <div className={infoboxClassName} role="article">
            {showIcon && (
                <span className="info-box__icon">
                    <Icon size={20} type={icon || iconType} />
                </span>
            )}
            <div className="info-box__content">{children}</div>
        </div>
    );
}

export default withTheme(Infobox);